import { RD_BASE } from './config';

/**
 * Submit general product feedback / bug reports (not to be confused with
 * submitFeedback() in projectCache.js, which is about AI scoring accuracy).
 * Relay-only by design — user_feedback has no anon policy, so there's no
 * direct-insert fallback to fall back to.
 */
export async function submitUserFeedback({ userId, email, type, message, page, projectName, lang }) {
  if (!['bug', 'idea', 'other'].includes(type) || !message?.trim()) return false;
  try {
    const res = await fetch(`${RD_BASE}/api/feedback/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId || null,
        email: email || null,
        type,
        message: message.trim(),
        page: page || null,
        project_name: projectName || null,
        lang: lang || null,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      }),
    });
    if (!res.ok) return false;
    const data = await res.json().catch(() => null);
    return !!data?.ok;
  } catch {
    return false;
  }
}
